<dynamic-material-form-control
  *ngFor="let controlModel of model; trackBy: trackByFn"
  [group]="group"
  [hidden]="controlModel.hidden"
  [layout]="layout"
  [model]="controlModel"
  [templates]="templates"
  (blur)="onBlur($event)"
  (change)="onChange($event)"
  (focus)="onFocus($event)"
  (matEvent)="onCustomEvent($event, matEvent)"
  [getLanguage]="getLanguage"
  [class]="controlModel.id"
></dynamic-material-form-control>

<ng-container *ngFor="let item of formControlTerms">
  <span class="control-terms" [ngClass]="item.class" [innerHTML]="item.key | cxTranslate"></span>
</ng-container>
